import React from 'react'
import Link from 'gatsby-link'
import {
  compose,
  lifecycle
} from 'recompose'
import { 
  Provider 
} from 'react-redux'
import { 
  createStore 
} from 'redux'
import loadjs from 'loadjs'
import Header from 'components/Header'
import reducers from 'reducers'

import 'normalize-css/normalize.css'
import 'ace-css/css/ace.min.css'
import 'css/style.css'

let store = createStore(reducers)

const Template = ({ children }) => (
  <Provider store={store}>
    <div className='template flex flex-column'>
      <Header />
      {children()}
    </div>
  </Provider>
)

const enhance = lifecycle({
  componentDidMount() {
    loadjs('https://use.typekit.net/bur7pjb.js', {
      success: () => Typekit.load({ async: true })
    })
  }
})

export default enhance(Template)



// WEBPACK FOOTER //
// ./src/layouts/index.js